<template>
  <z-page class="user-list">
    <!-- 搜索栏 -->
    <div class="page-search">
      <div class="search-item">
        <div>搜索：</div>
        <div class="long">
          <el-input
            size="mini"
            class="long"
            v-model="search.text"
            placeholder="关键字搜索"
            suffix-icon="el-icon-search"
          >
            <el-select class="long" v-model="search.text_type" slot="prepend" placeholder="请选择">
              <el-option label="产品名称" :value="1"></el-option>
              <el-option label="套餐名称" :value="2"></el-option>
            </el-select>
          </el-input>
        </div>
      </div>
      <div class="search-item">
        <div>时间：</div>
        <div class="long">
          <el-date-picker
            class="datepicker long"
            v-model="search.start_time"
            size="mini"
            type="month"
            value-format="timestamp"
            format="yyyy-MM "
            placeholder="选择日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
      </div>
      <div @click="getdata(1)" class="search-btn z-btn normal">搜索</div>
      <div @click="clearsearch" style="margin-left:20px;" class="search-btn">清除搜索</div>
    </div>
    <!-- 列表 -->
    <div class="page-list">
      <div class="list-head">
        <div>时间</div>
        <div>产品名称</div>
        <div>产品套餐</div>
        <div>客户经理</div>
        <div>提成类型</div>
        <div>提成比例/金额</div>
        <div>销售总额</div>
        <div>客户经理所得</div>
      </div>
      <div v-loading="loading" class="list-main">
        <div class="list-item" v-for="(item,index) in data_list" :key="index">
          <div>{{ item.statisticsMonth }}</div>
          <div>{{ item.productName ||'--' }}</div>
          <div>{{item.mealName||'--'}}</div>
          <div>{{ item.saleAccount||'--' }}</div>
          <div>{{item.saleCostType|saleDeptCostType}}</div>
          <div>{{ item.saleCostRate|fix}}{{(item.saleCostType=='0'||item.saleCostType=='2')?'%':(item.saleCostType=='1'?'元':'')}}</div>
          <div>{{ item.actualPayMoney }}</div>
          <div>{{ item.saleRoyalty }}</div>
        </div>
        <div style="text-align: center" v-if="data_list.length<=0" class="list-item">暂无数据</div>
      </div>
      <z-pagination
        @sizeChange="getdata()"
        @pageChange="handleCurrentChange"
        :current-page.sync="now_page"
        :page-size="10"
        :total="total"
      ></z-pagination>
    </div>
  </z-page>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      data_list: [],
      search: {
        text: "",
        text_type: null,
        start_time: ""
      },
      searching: {},
      now_page: 1,
      total: 0,
      // 限制时间
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created() {
    this.getdata(1);
  },
  methods: {
    clearsearch() {
      this.search.text_type = '';
      this.search.text = "";
      this.search.start_time = "";
      this.getdata(1);
    },
    //下载方法
    download() {
      this.$func.download("/api/supplier/sale/statistics/download", "提成统计");
    },
    searchData() {
      this.searching = this.search;
      this.handleCurrentChange(1);
    },
    clearData() {
      this.searching = {};
      this.search = {};
      this.handleCurrentChange(1);
    },
    getdata(num) {
      this.now_page=num||this.now_page
      this.loading = true;
      let url = `/api/supplier/get/sale/royalty/statistics`;
      this.$http
        .get(url, {
          params: {
            search_type: this.search.text_type,
            statistics_month:
              this.$func
                .myTimeToLocal(this.search.start_time)
                .substring(0, 7) || undefined, // 时间
            page: num || this.now_page, // 页码
            key_word: this.search.text || null //  产品名称
          }
        })
        .then(res => {
          console.log(res);

          if (res.code == "200") {
            this.data_list = res.res_data.list;
            this.total = res.res_data.total;
          } else {
            this.errorTip(res.res_data);
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.now_page = val;
      this.getdata();
    }
  }
};
</script>
<style lang="less" scoped>
.list-head,
.list-item {
  > div {
    width: 12.5%;
    &:nth-child(2) {
      //   width: 20%;
    }
  }
}
</style>

